import { TextField } from '@app/components/form-fields/TextField';
import type { AITextAgentListParams } from '@app/services/text-agent.types';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';

export type TextAgentFiltersProps = {
    onChange: (values: AITextAgentListParams) => void;
};

export const TextAgentFilters = ({ onChange }: TextAgentFiltersProps) => {
    const [filterSelection, setFilterSelection] = useState<AITextAgentListParams>({
        search: '',
        page: 1,
        per_page: 10,
    });

    useEffect(() => {
        onChange(filterSelection);
    }, [filterSelection]);

    return (
        <div>
            <TextField
                placeholder="Search AI Text Agents..."
                prefix={<MdSearch size={20} />}
                onChange={debounce((e) => {
                    setFilterSelection((prev) => ({
                        ...prev,
                        search: e.target.value,
                    }));
                }, 500)}
            />
        </div>
    );
};

export default TextAgentFilters;
